import React from "react";
import ViewContent from "./view-content";

// styling
import "./style.css";

export default () => (
  <div className="view">
    <div className="view-content">
      <div className="page-header">
        <h1>Dashboard</h1>
        <p>Latest statistics & summary</p>
      </div>
      <ViewContent />
    </div>
  </div>
);
